import { useState } from "react";
import "./add-modal-form/addModal.scss";
import icons from "../../../helpers/iconMenu";
import PaginationTable from "./PaginationTable";
import UpdateModal from "./update-modal-form/UpdateModal";
import { getRandomString } from '../../../helpers/helpers';
import Text from '../../../components/text-component/Text';
import Icon from "../../../components/icon-component/Icon";
import { getStaticText } from '../../../lables/lablesService';
import ConfirmModal from "./confirm-delete-modal/ConfirmModal";
import Spinner from '../../../components/spinner-component/Spinner';

/**
 * Languages table component
 * 
 * @params pages - var
 * @params errors - var
 * @params isEdit - boolean
 * @params loading - var
 * @params dataTable - arr obj
 * @params currentPage - var
 * @params setDataTable - func
 * @params updateRowValue - arr obj
 * @params setCurrentPage - func
 * @params handleValidation - func
 * 
 * @returns JSX
 */
const LanguagesTable = ({
    pages,
    errors,
    loading,
    dataTable,
    currentPage,
    setDataTable,
    fetchPageList,
    updateRowValue,
    setCurrentPage,
    handleSortRows,
    handleValidation,
    successfulUpdateMsg,
    fetchPageListSortIso,
    fetchPageListSortFlag,
    fetchPageListSortName,
    unsuccessfulUpdateMsg,
    setSuccessUpdatefulMsg,
    setUnsuccessfulUpdateMsg,
    fetchPageListSortIsDefault,
}) => {
    //State for confirm id
    const [confirmId, setConfirmId] = useState(null);
    //State for update rows 
    const [updatedValue, setUpdatedValue] = useState({});
    //State for active button color
    const [activeSorting, setActiveSorting] = useState('');
    //State for show/hide update popup form
    const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false);
    //State for show/hide confirm popup form
    const [isVisibleConfirmModal, setIsVisibleConfirmModal] = useState(false);

    //Render table header
    const renderHeader = () => {
        // Table header data
        const thead = [
            getStaticText('thead_number'),
            getStaticText('thead_name'),
            getStaticText('thead_ico'),
            getStaticText('thead_flag'),
            getStaticText('thead_is_default'),
            getStaticText('thead_action'),
        ]

        return (
            <>
                <th className='table-warning col-1 h6'>
                    <div className="d-flex align-items-center ">
                        <button
                            style={{ backgroundColor: activeSorting === 'id' ? '' : '#ebc334' }}
                            onClick={() => {
                                handleSortRows('id');
                                setActiveSorting('id');
                            }}
                            className="btn btn-danger p-0 pl-1 pr-1 m-1 border-0 shadow-none">
                            <Icon icon_style={icons.lng_sorting_btn} />
                        </button>
                        {thead[0]}
                    </div>
                </th>
                <th className='table-warning col-1 h6'>
                    <div className="d-flex align-items-center">
                        <button
                            style={{ backgroundColor: activeSorting === 'name' ? '' : '#ebc334' }}
                            onClick={() => {
                                handleSortRows('name');
                                setActiveSorting('name');
                                fetchPageListSortName();
                            }}
                            className="btn btn-danger p-0 pl-1 pr-1 m-1 border-0 shadow-none">
                            <Icon icon_style={icons.lng_sorting_btn} />
                        </button>
                        {thead[1]}
                    </div>
                </th>
                <th className='table-warning col-1 h6'>
                    <div className="d-flex  align-items-center">
                        <button
                            style={{ backgroundColor: activeSorting === 'iso' ? '' : '#ebc334' }}
                            onClick={() => {
                                handleSortRows('iso');
                                setActiveSorting('iso');
                                fetchPageListSortIso();
                            }}
                            className="btn btn-danger p-0 pl-1 pr-1 m-1 border-0 shadow-none">
                            <Icon icon_style={icons.lng_sorting_btn} />
                        </button>
                        {thead[2]}
                    </div>
                </th>
                <th className='table-warning col-1 h6'>
                    <div className="d-flex  align-items-center">
                        <button
                            style={{ backgroundColor: activeSorting === 'flag' ? '' : '#ebc334' }}
                            onClick={() => {
                                handleSortRows('flag');
                                setActiveSorting('flag');
                                fetchPageListSortFlag();
                            }}
                            className="btn btn-danger p-0 pl-1 pr-1 m-1 border-0 shadow-none">
                            <Icon icon_style={icons.lng_sorting_btn} />
                        </button>
                        {thead[3]}
                    </div>
                </th>
                <th className='table-warning col-2 h6'>
                    <div className="d-flex  align-items-center">
                        <button
                            style={{ backgroundColor: activeSorting === 'is_default' ? '' : '#ebc334' }}
                            onClick={() => {
                                handleSortRows('is_default');
                                setActiveSorting('is_default');
                                fetchPageListSortIsDefault();
                            }}
                            className="btn btn-danger p-0 pl-1 pr-1 m-1 border-0 shadow-none">
                            <Icon icon_style={icons.lng_sorting_btn} />
                        </button>
                        {thead[4]}
                    </div>
                </th>
                <th className='table-warning col-2 h6'>
                    <div className="pb-2">
                        {thead[5]}
                    </div>
                </th>
            </>
        )
    }

    /**
     * Method show hide update modal and set update row value
     * 
     * @params   id num
     * @params   name str
     * @params   iso  str
     * @params   flag str 
     * @params   is_default num 
     * @params   active num
     */
    const showUpdateModal = (id, name, iso, flag, is_default, active) => {
        const updateData = { id, name, iso, flag, is_default, active }
        setUpdatedValue(updateData);
        setIsVisibleUpdateModal(prev => !prev);
    }

    /**
     * Close update modal
     * @returns func
     */
    const closeUpdateModal = () => setIsVisibleUpdateModal(false)

    /**
     * Method to update the data row value
     * 
     * @params updatedData obj
     */
    const handleUpdate = updatedData => {
        dataTable = dataTable.map(({ id, ...rest }) => {
            return id === updatedData.id ? { id, ...updatedData } : { id, ...rest };
        })
        setDataTable(dataTable);
    }

    /**
     * Method to show/hide the confirmation modal and set the row id
     * 
     * @params event
     * @params id num
     */
    const showConfirmModal = id => {
        setConfirmId(id);
        setIsVisibleConfirmModal(prev => !prev)
    }

    /**
     * Close confirm modal
     * 
     * @returns fanc close modal
     */
    const closeConfirm = () => setIsVisibleConfirmModal(null);

    /**
     * Render table body
     * 
     * @returns jsx
     */
    const renderBody = () => {
        return dataTable &&
            dataTable?.map(({ id, name, iso, flag, is_default, active }) => (
                <tr key={getRandomString()}>
                    <td>{id}</td>
                    <td>{name}</td>
                    <td>{iso}</td>
                    <td>{flag}</td>
                    <td>
                        {is_default === 0 ? getStaticText('is_default_no') : getStaticText('is_default_yes')}
                    </td>
                    <td >
                        <button
                            type="button"
                            onClick={() => showUpdateModal(id, name, iso, flag, is_default, active)}
                            className='btn btn-primary pb-0 pt-0 p-2 m-1 shadow-none'
                        >
                            <Text
                                text_style={"m-0"}
                                content={getStaticText('btn_edit_lng')}
                            />
                        </button>
                        <button
                            type="button"
                            onClick={() => showConfirmModal(id)}
                            className='btn btn-danger pb-0 pt-0 p-3 m-1 shadow-none'
                        >
                            <Text
                                text_style={"m-0"}
                                content={getStaticText('btn_delete_lng')}
                            />
                        </button>
                    </td>
                </tr>
            ))
    }

    return (
        <>
            {
                loading ? <div className='text-center'>< Spinner /></div > :

                    <>
                        {/* Render update modal */}
                        {
                            isVisibleUpdateModal &&
                            <div className="overlay text-center">

                                <UpdateModal
                                    errors={errors}
                                    dataTable={dataTable}
                                    updatedValue={updatedValue}
                                    handleUpdate={handleUpdate}
                                    fetchPageList={fetchPageList}
                                    updateRowValue={updateRowValue}
                                    showUpdateModal={showUpdateModal}
                                    closeUpdateModal={closeUpdateModal}
                                    handleValidation={handleValidation}
                                    successfulUpdateMsg={successfulUpdateMsg}
                                    unsuccessfulUpdateMsg={unsuccessfulUpdateMsg}
                                    setSuccessUpdatefulMsg={setSuccessUpdatefulMsg}
                                    setUnsuccessfulUpdateMsg={setUnsuccessfulUpdateMsg}
                                />

                            </div>
                        }

                        {/* Render confirm modal */}
                        {
                            isVisibleConfirmModal &&
                            <div className="overlay text-center">

                                <ConfirmModal
                                    confirmId={confirmId}
                                    dataTable={dataTable}
                                    closeConfirm={closeConfirm}
                                    setDataTable={setDataTable}
                                    fetchPageList={fetchPageList}
                                />

                            </div>
                        }

                        {/* Render table */}
                        <section className='table-responsive mt-4'>
                            <table className="pt-3 table table-hover table-bordered">

                                <thead>
                                    <tr>{renderHeader()}</tr>
                                </thead>

                                <tbody>
                                    {renderBody()}
                                </tbody>

                            </table>
                        </section>
                        {
                            dataTable.length > 0 &&
                            <PaginationTable
                                pages={pages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                        }
                    </>
            }
        </>
    )
}

export default LanguagesTable;